import React from "react";
import { useTranslation } from "../context/TranslationContext";

const ReservationUnavailable = ({ message }) => {
  const { warning, reservationUnavailableMessage } = useTranslation();
  return (
    <div
      className="flex p-4 my-4 mx-3 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
      role="alert"
    >
      <div>
        {message || (
          <>
            <span className="font-medium">{warning}</span>{" "}
            {reservationUnavailableMessage}
          </>
        )}
      </div>
    </div>
  );
};

export default ReservationUnavailable;
